{
  "Add Provider": "Add Provider",
  "Back": "Back",
  "Book Appointment": "Book Appointment",
  "Botox / Neurotoxin Injections": "Botox / Neurotoxin Injections",
  "Chemical Peel": "Chemical Peel",
  "Child & Adolescent Session": "Child & Adolescent Session",
  "Cleaning & Exam": "Cleaning & Exam",
  "Comprehensive Exam": "Comprehensive Exam",
  "Congratulations! Your first appointment is booked": "Congratulations! Your first appointment is booked",
  "Contact Lens Fitting": "Contact Lens Fitting",
  "Couples Session": "Couples Session",
  "Crowns & Bridges": "Crowns & Bridges",
  "Custom": "Custom",
  "Dental Cleaning": "Dental Cleaning",
  "Dental Practice": "Dental Practice",
  "Dermal Fillers": "Dermal Fillers",
  "Diabetic Eye Exam": "Diabetic Eye Exam",
  "Don't worry, you can add more appointment types later": "Don't worry, you can add more appointment types later",
  "Dry Eye Evaluation": "Dry Eye Evaluation",
  "Duration": "Duration",
  "Eye Care / Optometry": "Eye Care / Optometry",
  "Fillings": "Fillings",
  "First Name": "First Name",
  "Follow-up Appointment": "Follow-up Appointment",
  "Glasses Fitting": "Glasses Fitting",
  "Group Session": "Group Session",
  "How long does it typically take?": "How long does it typically take?",
  "I don't want help setting up": "I don't want help setting up",
  "Individual Session": "Individual Session",
  "Industry Name": "Industry Name",
  "Initial Consultation": "Initial Consultation",
  "Laser Hair Removal": "Laser Hair Removal",
  "Last Name": "Last Name",
  "Let's book your first appointment to see how it works. A test contact has been set up for your practice": "Let's book your first appointment to see how it works. A test contact has been set up for your practice",
  "Medical Spa / Aesthetics": "Medical Spa / Aesthetics",
  "Mental Health / Therapy": "Mental Health / Therapy",
  "Microneedling": "Microneedling",
  "Mins": "Mins",
  "Minutes": "Minutes",
  "New Client": "New Client",
  "New Patient Consultation": "New Patient Consultation",
  "Next": "Next",
  "Other Industry": "Other Industry",
  "Other Service": "Other Service",
  "Patients like to know who they'll be seeing for": "Patients like to know who they'll be seeing for",
  "Perfect! Your scheduling is ready": "Perfect! Your scheduling is ready",
  "Ready to get booked?": "Ready to get booked?",
  "Remind Me Later": "Remind Me Later",
  "Schedule Functionality Demo Video": "Schedule Functionality Demo Video",
  "Select a Location": "Select a Location",
  "Service Type": "Service Type",
  "Set Up Now": "Set Up Now",
  "Set up auto reminder": "Set up auto reminder",
  "Set up automated reminders, confirmations, and follow-ups in under 5 minutes": "Set up automated reminders, confirmations, and follow-ups in under 5 minutes",
  "Set up now": "Set up now",
  "Set up your first appointment type in 3 easy steps": "Set up your first appointment type in 3 easy steps",
  "Sick Pet Visit": "Sick Pet Visit",
  "Skip": "Skip",
  "Spay/Neuter Surgery": "Spay/Neuter Surgery",
  "Step {{current}} of {{total}}": "Step {{current}} of {{total}}",
  "Stop playing phone tag to confirm appointments": "Stop playing phone tag to confirm appointments",
  "Stop wasting hours on weekly appointment confirmations": "Stop wasting hours on weekly appointment confirmations",
  "Teeth Whitening": "Teeth Whitening",
  "Upgrade Now": "Upgrade Now",
  "Vaccination": "Vaccination",
  "Veterinary Clinic": "Veterinary Clinic",
  "Want to prevent no-shows? Set up automatic reminders to cut last minute cancellations and no-show rates by 10%": "Want to prevent no-shows? Set up automatic reminders to cut last minute cancellations and no-show rates by 10%",
  "Want to prevent no-shows? Upgrade your bundle to to cut last minute cancellations and no-show rates by 10%": "Want to prevent no-shows? Upgrade your bundle to to cut last minute cancellations and no-show rates by 10%",
  "Watch how structured appointment management frees up 3+ hours weekly for patient care instead of admin tasks": "Watch how structured appointment management frees up 3+ hours weekly for patient care instead of admin tasks",
  "We'll customize your setup based on your practice type.": "We'll customize your setup based on your practice type.",
  "Wellness Exam": "Wellness Exam",
  "What type of practice do you run?": "What type of practice do you run?",
  "What's your most booked appointment?": "What's your most booked appointment?",
  "Which location should we start with?": "Which location should we start with?",
  "Who will be providing this service?": "Who will be providing this service?",
  "You'll be able to configure the rest later": "You'll be able to configure the rest later",
  "Yrs": "Yrs"
}
